import React, { useState } from "react";

import { ScatterControls } from "./ScatterControls";
import { ScatterChart } from "./ScatterChart";
import { StewardshipFilterParam } from "../../../models/stewardshipModels";
import { useStewardshipScatter } from "../../../hooks/useEngagementMaterialityScatter";
import {
  Card,
  FlexibleContainer,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { EngagementMaterialityClusterModal } from "./EngagementMaterialityClusterModal";
import { DataPoint } from "./util";

export const StewardshipScatter = ({
  filters,
}: StewardshipScatter): JSX.Element => {
  const {
    isLoading,
    includeNonEngaged,
    setIncludeNonEngaged,
    maxClusters,
    setMaxClusters,
    maxClusterSlider,
    updateCompaniesSliderRange,
    clusteredData,
    clusteredPoints,
    totalCompanies,
  } = useStewardshipScatter({ filters });

  const [showClusterModal, setShowClusterModal] = useState(false);
  const [rawClusterData, setRawClusterData] = useState<DataPoint[]>([]);

  const handleShowClusterModal = (clusterId: string): void => {
    setShowClusterModal(true);
    const cluster = clusteredPoints.find((c) => c.id === clusterId) ?? null;
    setRawClusterData(cluster?.items ?? []);
  };

  return (
    <Card h="100%" m="0 20px" isLoading={isLoading}>
      <RowContainer>
        <CompassParagraph fontSize={16} bold={true}>
          Engagement Materiality Map
        </CompassParagraph>
      </RowContainer>
      <FlexibleContainer fd="row" ai="flex-start">
        <ScatterControls
          isLoading={isLoading}
          maxClusters={maxClusters}
          setMaxClusters={setMaxClusters}
          maxClusterSlider={maxClusterSlider}
          includeNonEngaged={includeNonEngaged}
          setIncludeNonEngaged={setIncludeNonEngaged}
          totalCompanies={totalCompanies}
          onRangeChange={updateCompaniesSliderRange}
          clustersCount={clusteredPoints.length}
        />
        <ScatterChart
          data={clusteredData}
          isLoading={isLoading}
          onPointClick={handleShowClusterModal}
        />
      </FlexibleContainer>
      <EngagementMaterialityClusterModal
        show={showClusterModal}
        handleClose={(): void => setShowClusterModal(false)}
        rawClusterData={rawClusterData}
      />
    </Card>
  );
};

type StewardshipScatter = {
  filters: StewardshipFilterParam;
  totalCompanies?: number;
};
